import React from "react";
import { Trophy } from "lucide-react";


const TopProjectTV2 = () => {
  return (
    <section >
      {/* 🔼 Upper hero section */}
      <TopProjectTVUpper />

      {/* 🔽 Lower section: multiple TVs */}
      <TopProjectTV2222 />
    </section>
  );
};

const TopProjectTVUpper = () => {
  const capsules = [
    { label: "🚀 Deployed", color: "#07ae18ff", bg: "rgba(24,198,41,0.1)" },
    { label: "🤝 Client: Multinational Food Corporation", color: "#555", bg: "rgba(0,0,0,0.03)" },
    { label: "🔒 Private • Demo can be shared privately under NDA", color: "#d63384", bg: "rgba(214,51,132,0.05)" },
  ];

  const sections = [
    {
      title: "✨ What it does",
      description: "The first commercial app to control Android TVs globally using React Native without any specialized hardware. It handles synchronized video walls, screen capture, and playlist assignments for individual TVs or groups."
    },
    {
      title: "⚙️ How it works",
      description: "Syncs multiple TVs with sub-30ms latency. Activation is simple: install the Android client app, scan a QR code from the dashboard on your phone, and you’re ready to go."
    },
    {
      title: "🖥️ Tech Stack",
      description: "Built with SQL, Python, FastAPI, ReactJS, and React Native. Supports 15,000–18,000 TVs simultaneously at ~$20/month, ensuring high scalability and reliability."
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        padding: "80px 20px",
        maxWidth: "1240px",
        margin: "0 auto",
        gap: "40px",
      }}
    >
      {/* Left: Project Info */}
      <div style={{ flex: "1 1 500px", minWidth: "320px" }}>
        {/* <h2 style={{ fontSize: "2rem", fontWeight: "700", marginBottom: "20px" }}>
          Top Project • Global Video Wall Platform
        </h2> */}
        <h2
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              marginBottom: "24px",
              color: "#2b213b",
              lineHeight: "1.2",
              fontFamily: "Inter",
            }}
          >
            Top Project •{" "}
            <span style={{ color: "#db2254", fontFamily: "Inter", }}>Global Video Wall Platform</span>
          </h2>

        {/* Capsules */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "20px", flexWrap: "wrap", paddingRight: "500px" }}>
                      {/* {capsules.map((cap, idx) => (
              <span
                key={idx}
                style={{
                  padding: "6px 14px",
                  border: `1px solid ${cap.color}`,
                  borderRadius: "999px",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  color: cap.color,
                  backgroundColor: cap.bg,
                  whiteSpace: "nowrap",
                }}
              >
                {cap.label}
              </span>
            ))} */}
            {capsules.map((cap, idx) => (
  <span
    key={idx}
    style={{
      padding: "6px 14px",
      border: `1px solid ${cap.color}`,
      borderRadius: "999px",
      fontSize: "0.9rem",
      fontWeight: "600",
      color: cap.color,
      backgroundColor: cap.bg,
      whiteSpace: "nowrap",
      marginRight: idx === capsules.length - 1 ? "520px" : "0", // only last capsule
    }}
  >
    {cap.label}
  </span>
))}
        </div>

        {/* Sections */}
        {sections.map((sec, idx) => (
          <div key={idx} style={{ marginBottom: "20px" }}>
            {/* <h3 style={{ fontSize: "1.25rem", fontWeight: "700", marginBottom: "8px" }}>{sec.title}</h3>
            <p style={{ fontSize: "1rem", color: "#555", lineHeight: "1.6" }}>{sec.description}</p> */}
                          <h3
                style={{
                  fontSize: "1.35rem",
                  fontWeight: "700",
                  marginBottom: "8px",
                  color: "#2b213b",
                }}
              >
                {sec.title}
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#555",
                  lineHeight: "1.7",
                  maxWidth: "600px",
                }}
              >
                {sec.description}
              </p>
          </div>
        ))}
      </div>

      {/* Right: Trophy with glow & subtle animation */}
      <div
        style={{
          flex: "1 1 300px",
          minWidth: "300px",
          display: "flex",
          justifyContent: "center",
          position: "relative",
        }}
      >
        {/* Glowing halo */}
        <div
          style={{
            position: "absolute",
            width: "140px",
            height: "140px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(255,215,0,0.4) 0%, rgba(255,215,0,0) 70%)",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            filter: "blur(24px)",
            zIndex: 0,
          }}
        ></div>

        <div
          style={{
            fontSize: "4rem",
            color: "#FFD700",
            zIndex: 1,
            transition: "transform 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Trophy size={64} color="#FFD700" />
        </div>
                  <p style={{
            position: "absolute",
            height: "140px",
            top: "120%",
            left: "50%",
            zIndex: 0,
            color: "#FFD700",
            transform: "translateX(-50%)",
            textAlign: "center",
    fontWeight: "600",
    fontSize: "1.5rem",
          }}>First of its kind</p>
      </div>
    </div>
  );
};


const TopProjectTV2222 = () => {
  const steps = [
    {
      number: 1,
      title: "Launch App",
      description: "Open the Android TV app to initialize the connection.",
    },
    {
      number: 2,
      title: "Scan QR Code",
      description: "Pair your TV instantly by scanning a QR code from the dashboard.",
    },
    {
      number: 3,
      title: "Control Dashboard",
      description: "Manage playlists and TVs directly from the web dashboard.",
    },
  ];

  return (
    <div
      style={{
        maxWidth: "1240px",
        margin: "0 auto",
        padding: "80px 20px",
        paddingTop: "0px",
        paddingBottom: "80px"
      }}
    >
      <h2
        style={{
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: "700",
          marginBottom: "60px",
          fontFamily: "Inter",
        }}
      >
        {/* Global Video Wall Platform – How it Works */}
        Easy Setup in <span style={{ color: "#db2254", fontFamily: "Inter, sans-serif", fontSize: "2rem" }}>3 STEPS</span>
      </h2>

      {/* Timeline container */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          position: "relative",
          flexWrap: "wrap",
          gap: "40px",
        }}
      >
        {/* Horizontal timeline line */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            left: "5%",
            width: "90%",
            height: "4px",
            backgroundColor: "#db2254",
            zIndex: 0,
            display: window.innerWidth < 1020 ? "none" : "block",
          }}

        />

        {steps.map((step, idx) => (
          <div
            key={idx}
            style={{
              flex: "1 1 300px",
              minWidth: "280px",
              textAlign: "center",
              position: "relative",
              zIndex: 1,
            }}
          >
            {/* Step number */}
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#db2254",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "700",
                fontSize: "1.1rem",
                margin: "0 auto 16px auto",
                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              }}
            >
              {step.number}
            </div>

            {/* TV mockup */}
            <div
              style={{
                width: "100%",
                maxWidth: "320px",
                aspectRatio: "16 / 9",
                borderRadius: "16px",
                border: "2px solid #000",
                margin: "0 auto 16px auto",
                position: "relative",
                backgroundColor: "#000",
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              }}
            >
              {/* Screen area */}
              <div
                style={{
                  position: "absolute",
                  inset: "8px",
                  borderRadius: "12px",
                  backgroundColor: "#1c1725ff",
                  zIndex: 1, // push behind
                  display: "flex",
  justifyContent: "center",   // horizontal centering
  alignItems: "center"        // vertical centering
                }}
              ><p style={{ color: "white" }}>Private</p></div>

              {/* TV legs (realistic) */}
              <div
                style={{
                  position: "absolute",
                  bottom: "-16px",
                  left: "25%",
                  width: "20px",
                  height: "40px",
                  backgroundColor: "#333",
                  borderRadius: "4px",
                  transform: "skewX(-10deg)",
                   zIndex: 0, // push behind
                }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "-16px",
                  right: "25%",
                  width: "20px",
                  height: "40px",
                  backgroundColor: "#333",
                  borderRadius: "4px",
                  transform: "skewX(10deg)",
                  zIndex: 0, // push behind
                }}
              />
            </div>

            {/* Step text */}
            <h3 style={{ fontSize: "1.25rem", marginBottom: "8px" }}>{step.title}</h3>
            <p style={{ fontSize: "1rem", color: "#555" }}>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopProjectTV2;
